export default __webpack_public_path__ + "static/media/infrastructure.764d90e6.jpeg";